module.exports = __webpack_public_path__ + "bce551f1f81d49adee0fc5962adeee7e.svg";